export const enum ExtraFacilities {
  InHouse = -1,
  Unspecified = -2,
}
